export const makeIntlFormats = () => ({
  number: {
    price: {
      style: 'currency',
      currency: 'USD',
    },
  },
})

/**
 * Creates a messages object with fallback support.
 * Missing keys in the target locale will fall back to the default locale.
 *
 * @param targetMessages - Messages for the target locale
 * @param defaultMessages - Messages for the default locale (fallback)
 * @returns Merged messages object
 */
export function createMessagesWithFallback<T extends Record<string, string>>(
  targetMessages: T,
  defaultMessages: T
): T {
  return { ...defaultMessages, ...targetMessages }
}
